import type { Dict } from "../core.js";
import type { teams as vi } from "../vi/teams.js";

export const teams: Dict<typeof vi> = {
  loadFailed: "Couldn't load the team list.",
  loadDetailFailed: "Couldn't load team details.",
  addFailed: "Couldn't add the member.",
  removeFailed: "Couldn't remove the member.",
  title: "Teams",
  introBefore: "A team is the unit that takes responsibility on the Ownership page. An ",
  introStrong: "empty",
  introAfter: " team makes a service look owned while nobody is on the hook — worse than not assigning it at all.",
  emptyTitle: "No teams yet.",
  emptyHint: "Create a team on the Ownership page, then come back here to add members.",
  empty: "empty",
  memberCountOne: "{count} member",
  memberCount: "{count} members",
  noMembersBefore: "This team ",
  noMembersStrong: "has no members",
  noMembersAfter: ". Services assigned to it will look owned while nobody is actually responsible.",
  "col.member": "Member",
  "col.teamRole": "Team role",
  "col.inHub": "In hub",
  active: "Active",
  leftHub: "Left the hub",
  remove: "Remove",
  addMember: "Add member",
  pickPerson: "Choose a person…",
  activeOnly: "Only people active in the hub.",
};
